import React from 'react';
import { Link } from 'react-router-dom';
import useMeta from '../hooks/useMeta';

export default function Forbidden() {
  useMeta(
    'Adgang nægtet - Danry Diamant Boring ApS',
    'Du har ikke adgang til denne side. Gå tilbage til forsiden af Danry Diamant Boring ApS.'
  );

  return (
    <div className="pt-[90px] lg:pt-[120px] min-h-[calc(100vh-120px)] flex items-center justify-center bg-white relative overflow-hidden py-20">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-brand-orange/5 rounded-full blur-[80px] pointer-events-none" />

      <div className="max-w-md w-full px-6 text-center flex flex-col items-center gap-6 relative z-10">
        <div className="w-20 h-20 rounded-2xl bg-red-500/10 border border-red-500/20 flex items-center justify-center text-red-500 text-4xl shadow-lg shadow-red-500/5">
          <i className="fa-solid fa-lock" />
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="text-7xl font-extrabold text-neutral-900 tracking-tight uppercase">403</h1>
          <h2 className="text-2xl font-bold text-neutral-900 uppercase">Adgang nægtet</h2>
          <p className="text-sm text-neutral-600 leading-relaxed mt-2">
            Du har desværre ikke de nødvendige rettigheder til at tilgå denne side eller ressource.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 w-full mt-4">
          <Link
            to="/"
            className="flex-1 py-3 rounded-full bg-brand-orange hover:bg-brand-orange-hover text-white font-bold text-sm transition-colors shadow-md shadow-brand-orange/10 text-center"
          >
            Gå til forsiden
          </Link>
          <Link
            to="/kontakt"
            className="flex-1 py-3 rounded-full bg-neutral-100 hover:bg-neutral-200 border border-neutral-200 text-neutral-800 font-bold text-sm transition-colors text-center"
          >
            Kontakt os
          </Link>
        </div>
      </div>
    </div>
  );
}
